<template lang="html">
  <div id="suites-page" class="contained-height">
    <div class="container-fluid">
      <div class="row position-relative">
        <img
          v-for="(image, slideIndex) in activeSlides"
          class="builder-image"
          :src="assetsUrl + image.url"
          :class="{ active: slideIndex === index }"
          :key="image.id"
        >
      </div>
      <div class="neighbourhood-arrows position-absolute d-flex flex-row align-items-center justify-content-end">
        <div class="index pr-4">
          {{ index + 1 }} / {{ activeSlides.length || 0}}
        </div>
        <div class="arrow-container d-flex flex-row align-items-center justify-content-end">
          <div class="neighbourhood-arr d-flex flex-row align-items-center justify-content-center" @click="prevSlide()">
            <i class="fal fa-long-arrow-left"></i>
          </div>
          <div class="neighbourhood-arr d-flex flex-row align-items-center justify-content-center" @click="nextSlide()">
            <i class="fal fa-long-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      index: 0,
      currentPage: ''
    };
  },
  computed: {
    ...mapState({
      slides: state => state.amenities.suiteDetails,
      assetsUrl: state => state.project.assetsUrl
    }),
    activeSlides() {
      return this.slides[this.currentPage] || [];
    }
  },
  methods: {
    ...mapMutations({
      setPageReady: 'ui/setPageReady'
    }),
    prevSlide() {
      this.index -= 1;
      if (this.index < 0) {
        this.index = this.activeSlides.length - 1;
      }
    },
    nextSlide() {
      this.index += 1;
      if (this.index === this.activeSlides.length) {
        this.index = 0;
      }
    },

  },
  mounted() {
    this.currentPage = this.$route.params.page;
    this.setPageReady(true);
  },
  beforeDestroy() {
    this.setPageReady(false);
  },
  watch: {
    '$route.params.page'() {
      this.index = -1;
      setTimeout(() => {
        this.index = 0;
      }, 500);
      setTimeout(() => {
        this.currentPage = this.$route.params.page;
      }, 500);
    }
  },
  components: {
  }
};
</script>

<style lang="scss" scoped>

#suites-page {
  width: 100%;
  height: 100%;
  padding-left: calc(#{$neighbourhoodNavWidth});
}

</style>



// WEBPACK FOOTER //
// src/pages/AmenitiesPage/pages/AmenitiesSuitesPage.vue